<template>
<v-layout row wrap>
<v-flex xs8 offset-xs2>
    <v-expansion-panel
      v-model="groups"
      expand
    >
      <v-expansion-panel-content
        v-for="item in commands"
        :key="item.title"
      >
        <template v-slot:header>
          <div>#Category: {{ item.title }}</div>
        </template>
        <v-card dark>
          <v-card-text class="blue lighten-5">

              <v-expansion-panel
                  v-model="item.taps"
                  expand
                >
                  <v-expansion-panel-content
                    v-for="com in item.commands"
                    :key="com.title"
                  >
                    <template v-slot:header>
                      <div>#{{ com.title }}</div>
                    </template>
                    <v-card dark>
                      <v-card-text class="blue lighten-0">

                          <br><h3 class="headline mb-0" v-html="com.info ? `#Info: ${com.info}` : ''"/>
                          <br><h3 class="headline mb-0" v-html="com.usage ? `#Usage: ${FixPrefix(com.usage)}` : ''"/>
                          <br><h3 class="headline mb-0" v-html="com.description ? `#Description: ${FixPrefix(com.description)}` : ''"/>

                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>

          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
</v-flex>
</v-layout>
</template>

<script>
import { commands } from '../plugins/commands'

const prefix = '>'

export default {
  name: 'commands',
  data: () => ({
    commands: commands[2].commands,
    groups: [],
    command: [],
    prefix
  }),
  methods: {
    FixPrefix (prefix) {
      return prefix.split('<prefix>').join(this.prefix)
    }
  },
  watch: {
    '$route' (to) {
      if (to.query.group) {
        this.groups = [...Array(this.commands.length).keys()].map(a => Number(to.query.group) === a ? true : false)
      }
    }
  }
}
</script>

<style>
.theme--dark.v-expansion-panel .v-expansion-panel__container {
  background-color: #9c27b0 !important
}
</style>
